export const SHOW_MODAL = 'showModal';
export const REBUILD_PATH = 'rebuildPath';
export const SHOW_OVERLAY = 'showOverlay';
export const NOTIFY_ERROR = 'notifyError';
export const GUIDE_JUMP_TO = 'guideJumpTo';
export const DROP_OVERLAY = 'dropOverlay';
export const SUCCESS_SEARCH = 'successSearch';
export const RESTORE_LOCALE = 'restoreLocale';
export const PATH_REBUILDED = 'pathRebuilded';
export const GUIDE_NEW_POINT = 'guideNewPoint';
export const UNSUCCESS_SEARCH = 'unsuccessSearch';
export const SESSION_EXTENDED = 'sessionExtended';
export const LOADING_PROGRESS = 'loadingProgress';
export const NO_DIRECT_MATCHES = 'noDirectMatches';
export const SEARCH_DATA_CHANGE = 'searchDataChange';
export const CHECK_SEARCH_VALUE = 'checkSearchValue';
export const SESSION_TERMINATED = 'sessionTerminated';
export const ERASE_SEARCH_STRING = 'eraseSearchString';
export const START_GUIDE_OVERVIEW = 'startGuideOverview';
export const GUIDE_CLOSE_SEARCHBAR = 'guideCloseSearchbar';
